// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1612":"8003e206","1742":"a1c6c319"}[chunkId] + ".chunk.css";
};